<template>
  <svg width="16px" height="16px"
       viewBox="0 0 16 16" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/16x16/check/white</title>
    <g id="atoms/icons/16x16/check/white" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M11.9456115,4.30710678 C12.3361358,3.91658249 12.9693007,3.91658249 13.359825,4.30710678 C13.7503493,4.69763107 13.7503493,5.33079605 13.359825,5.72132034 L7.34941738,11.731728 C7.27557994,11.8055654 7.19306846,11.8654422 7.105163,11.9113584 C6.71514017,12.1896967 6.16945867,12.1536722 5.8190873,11.8033009 L2.63710678,8.62132034 C2.24658249,8.23079605 2.24658249,7.59763107 2.63710678,7.20710678 C3.02763107,6.81658249 3.66079605,6.81658249 4.05132034,7.20710678 L6.54821356,9.70321356 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
